export const DEFAULT_OTP_EXPIRY_SECONDS = 180; // 3 minutes
export const DEFAULT_RESEND_OTP_EXPIRY_SECONDS = 600; // 10 minutes
export const DEFAULT_OTP_LENGTH = 4;
export const DEFAULT_EMAIL_DOMAIN = '@stengg.com';
export const DEFAULT_MAX_RESEND_ATTEMPTS = 3;
